export default "__VITE_ASSET__ChxdFMgN__"